import styled from "styled-components";

export const Wrapper = styled("div")(({ theme }) => ({
  backgroundColor: theme.palette.gray[100],
  flexGrow: 1,
  padding: "30px 0",
  minHeight: "calc(100vh - 200px)",

  // FE-34: там, где показывается липкая панель с ценой, последний блок
  // страницы иначе уезжает под неё. --sticky-bar-h публикует сама панель.
  [theme.down("lg")]: {
    paddingBottom: `calc(var(--sticky-bar-h, 0px) + ${theme.spacing(5)}px)`,
  },

  [theme.down("sm")]: {
    padding: "15px 0",
    paddingBottom: `calc(var(--sticky-bar-h, 0px) + ${theme.spacing(4)}px)`,
  },
}));

export const Block = styled("div")(({ theme }) => ({
  ...theme.mixins.flexJustifyBetween,
  alignItems: "flex-start",
  gap: 20,
  padding: "10px 0",

  [theme.down("lg")]: {
    flexDirection: "column",
    gap: 15,
  },

  [theme.down("sm")]: {
    padding: "5px 0",
  },
}));

export const RoutesDataAndFormBlock = styled("div")(({ theme }) => ({
  ...theme.mixins.flexColumn,
  flexGrow: 1,
  gap: 20,
  order: 1,

  [theme.down("lg")]: {
    width: "100%",
    order: 2,
  },

  [theme.down("sm")]: {
    gap: 15,
  },
}));

export const PriceAndButtonsBlock = styled("div")(({ theme }) => ({
  ...theme.mixins.flexColumn,
  gap: 20,
  order: 2,

  [theme.down("lg")]: {
    width: "100%",
    order: 1,
  },

  [theme.down("sm")]: {
    gap: 15,
  },
}));

export const DisclaimerBanner = styled("div")(({ theme }) => ({
  borderRadius: 8,
  overflow: "hidden",
  border: `1px solid ${theme.palette.warning.main}`,
  boxShadow: `0 2px 8px ${theme.palette.shadow.medium}`,
  marginTop: 8,
}));

export const DisclaimerHeader = styled("div")(({ theme }) => ({
  ...theme.mixins.flexAlignCenter,
  backgroundColor: theme.palette.warning.main,
  height: 46,
  cursor: "pointer",
  padding: "0 16px",
  gap: 10,
  userSelect: "none",

  [theme.down("sm")]: {
    height: 42,
    padding: "0 12px",
  },
}));

export const DisclaimerIcon = styled("span")({
  fontSize: 20,
  lineHeight: 1,
  flexShrink: 0,
});

export const DisclaimerTitle = styled("div")(({ theme }) => ({
  flexGrow: 1,
  fontWeight: 700,
  fontSize: 13,
  color: theme.palette.white,
  letterSpacing: "0.06em",
  textTransform: "uppercase",

  [theme.down("sm")]: {
    fontSize: 12,
  },
}));

export const DisclaimerToggle = styled("div")(({ theme, $isOpen }) => ({
  ...theme.mixins.flexCenterCenter,
  color: theme.palette.white,
  transition: "transform 0.3s ease",
  transform: $isOpen ? "rotate(90deg)" : "rotate(0deg)",
  fontSize: 14,
}));

export const DisclaimerContent = styled("div")(({ theme, $isOpen }) => ({
  backgroundColor: "rgba(247, 148, 29, 0.06)",
  padding: $isOpen ? "16px 20px" : 0,
  maxHeight: $isOpen ? 300 : 0,
  overflow: "hidden",
  transition: "max-height 0.3s ease, padding 0.3s ease",

  [theme.down("sm")]: {
    padding: $isOpen ? "12px 14px" : 0,
  },
}));

export const DisclaimerText = styled("p")(({ theme }) => ({
  margin: 0,
  fontSize: 13,
  lineHeight: 1.65,
  color: theme.palette.gray[800],

  [theme.down("sm")]: {
    fontSize: 12,
  },
}));
